import './Stepper.css';

interface Step {
  id: number;
  title: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: number;
}

export function Stepper({ steps, currentStep }: StepperProps) {
  return (
    <div className="stepper">
      {steps.map((step) => {
        const isActive = step.id === currentStep;
        return (
          <div key={step.id} className={`step-card ${isActive ? 'active' : ''}`}>
            <div className="step-number">{step.id}</div>
            <div className="step-title">{step.title}</div>
          </div>
        );
      })}
    </div>
  );
}
